var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticClass: "py-2" },
        [
          _c("v-icon", { staticClass: "mr-2" }, [_vm._v("merge_type")]),
          _vm._v(" "),
          _c("div", { staticClass: "title info--text" }, [_vm._v("Aliases")]),
          _vm._v(" "),
          _c("div", { staticClass: "title pl-1" }, [_vm._v(" ⋅ ")]),
          _vm._v(" "),
          _c("div", { staticClass: "caption pl-1" }, [
            _vm._v(
              " " +
                _vm._s(_vm.aliases.length) +
                " " +
                _vm._s(_vm.pluralize("alias", _vm.aliases.length, "es"))
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _vm.editForm
        ? [
            _c(
              "v-card-actions",
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "success",
                      small: "",
                      disabled: _vm.makePrimaryIsLoading,
                    },
                    on: { click: _vm.showAddAliaasDialog },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                    _vm._v("\n        Add\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "warning",
                      small: "",
                      disabled: _vm.makePrimaryIsLoading,
                    },
                    on: { click: _vm.showMergeAliasDialog },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [
                      _vm._v("merge_type"),
                    ]),
                    _vm._v("\n        Merge Existing\n      "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("v-card-text", [
        _c("p", [
          _c("strong", [_vm._v("Name aliases")]),
          _vm._v(" are alternative names for this data source.\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          "hide-actions": "",
          items: _vm.aliases,
          "no-data-text": "No aliases",
          "hide-headers": "",
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function ({ item }) {
              return [
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c("v-chip", { attrs: { label: "", small: "" } }, [
                      _vm._v(" " + _vm._s(item.Name)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-right" }, [
                  item.IsPrimary
                    ? _c(
                        "span",
                        { staticClass: "caption info--text font-weight-" },
                        [
                          _vm._v("Primary\n          "),
                          _c("Tooltip", { attrs: { small: "" } }, [
                            _c("div", [
                              _vm._v(
                                "The primary name shows up in reports for this data source."
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.primaryAliasNameDifferentFromDataSourceName
                              ? _c("div", [
                                  _c("strong", [_vm._v("Note:")]),
                                  _vm._v(
                                    " The primary alias is currently different than the location name.\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editForm && !item.IsPrimary,
                          expression: "editForm && !item.IsPrimary",
                        },
                      ],
                    },
                    [
                      _vm.isSystemAdmin
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "info",
                                small: "",
                                loading: item.IsLoading,
                                disabled: _vm.makePrimaryIsLoading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.makePrimary(item)
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-2" }, [
                                _vm._v("admin_panel_settings"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text--capitalize" }, [
                                _vm._v(
                                  "\n              Make primary\n            "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { "open-delay": 500, left: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editForm && !item.IsPrimary,
                                              expression:
                                                "editForm && !item.IsPrimary",
                                            },
                                          ],
                                          attrs: {
                                            icon: "",
                                            disabled: _vm.makePrimaryIsLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showUnmergeAliasDialog(
                                                item.Name
                                              )
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "warning" } },
                                          [_vm._v("call_split")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v("Separate alias from current data source"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("AddAliasDialog", {
        ref: "add-alias-dialog",
        attrs: { dataSourceIndex: _vm.dataSourceIndex },
      }),
      _vm._v(" "),
      _c("MergeAliasDialog", {
        ref: "merge-alias-dialog",
        attrs: { dataSourceIndex: _vm.dataSourceIndex },
      }),
      _vm._v(" "),
      _c("UnmergeAliasDialog", {
        ref: "unmerge-alias-dialog",
        attrs: { dataSourceIndex: _vm.dataSourceIndex },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }